export default "__VITE_ASSET__TrXVJ6fQ__"